<template>
  <b-card>
    <template-email-list
      id="templateemailList"
      ref="templateemailList"
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :filtros="filtrosPrincipais"
      :info="info"
      :permissao-delete-props="false"
    />
  </b-card>
</template>

<style lang="scss">

.linha-vertical {
  height: 30px;/*Altura da linha*/
  border-right: 1px solid rgb(163 164 166 / 88%);/* Adiciona borda direita na div como ser fosse uma linha.*/
}

.badge-dados-empresa {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}

.badge-dados-controle {
  height: 1.3rem;
  font-size: 10px;
  font-weight: 750;
  border-radius: 2px;
  margin-left: 0.5rem;
  padding: 4px;
}

.badge-parcial {
  background-color: #ff8d00;
}

.badge-controle {
  border-width: 1px;
  border-style: solid;
}

.badge-vencido {
  color: #ea5455;
  border: 1px solid #ea5455;
  background-color: transparent;
}

</style>

<script>
import api from '@/app-modulo/comuns/templates-gerais/shared/components/services/api'

export default {
  name: 'TemplateEmailVisualizacao',
  components: {
    templateEmailList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [
        {
          label: 'Descrição', field: 'descricao', showActive: true, editable: true,
        },
        { label: 'Tipo do e-mail', field: 'tipoEmail' }],
      filtrosPrincipais: [{ colunas: ['Descricao', 'TipoEmail'], valor: null }],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
      carregado: false,
    }
  },
  computed: {
  },
  methods: {
    carregar(page, pageSize, filtro) {
      this.carregado = true
      const resp = api.getTemplates(page, pageSize, filtro)
      return resp
    },
    novo() {
      this.$router.push({ name: 'novo-template-email' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-template-email', params: { id: value.id } })
    },
    remover(values) {
      if (values && values.length === 1) {
        return new Promise((resolve, reject) => {
          api.delete(values[0].id)
            .then(() => {
              resolve(false)
            })
            .catch(err => {
              reject(err)
            })
        })
      }

      const idList = values.map(map => map.id)
      return new Promise((resolve, reject) => {
        api.deleteAll({ identificadores: idList })
          .then(() => {
            resolve(false)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
  },
}
</script>
